<template>
  <div class="shell">
    <header class="top" v-if="!isLogin">
      <div class="brand">
        <span class="mark" aria-hidden="true"></span>
        <div>
          <p class="eyebrow">Painel</p>
          <h1>{{ assistantName }}</h1>
        </div>
      </div>
      <nav>
        <RouterLink to="/">Dashboard</RouterLink>
        <RouterLink to="/ferramentas">Ferramentas</RouterLink>
        <RouterLink to="/sites">Sites e Acessos</RouterLink>
        <RouterLink to="/integracoes">Integrações</RouterLink>
        <RouterLink to="/logs">Logs</RouterLink>
        <RouterLink to="/configuracoes">Configurações</RouterLink>
        <button type="button" class="linkish" @click="onLogout">Sair</button>
      </nav>
    </header>
    <main>
      <RouterView />
    </main>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, watch } from 'vue';
import { RouterLink, RouterView, useRoute, useRouter } from 'vue-router';
import { assistantName, loadAssistantIdentity } from './assistant-name';
import { logout } from './auth';

const route = useRoute();
const router = useRouter();
const isLogin = computed(() => route.name === 'login');

async function onLogout() {
  await logout();
  await router.push({ name: 'login' });
}

onMounted(loadAssistantIdentity);
watch(() => route.path, () => {
  void loadAssistantIdentity();
});
</script>
